/**
 * Network Error Utilities
 *
 * Utility functions for detecting and handling network-related errors.
 */

/**
 * Determines if an error is caused by network connectivity issues.
 * Checks navigator.onLine status and common network error messages.
 *
 * @param error - The error to check
 * @returns true if the error appears to be network-related, false otherwise
 */
export const isOfflineOrNetworkFetchError = (error: Error): boolean => {
  const message = (error?.message || '').toLowerCase();

  // Check if browser reports being offline
  if (typeof navigator !== 'undefined' && navigator.onLine === false) {
    return true;
  }

  // Check for common network error message patterns
  return message.includes('failed to fetch') || message.includes('networkerror') || message.includes('network error');
};
